module.exports = __webpack_public_path__ + "media/images/card-jcb-0b0b3b79d1f2b067195704aacd3b3a91.svg";